import React, { useEffect } from "react";
import "./Invitation_Rules.css";
import Rules_card from "../Common/Common_Component/Rules_card/Rules_card";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { AppSetup } from "../../features/admin/common/Slice";

function Invitation_Rules() {
  const dispatch = useDispatch();

  const appSetup = useSelector((state) => state.common.app_setup);
  console.log({ appSetup });

  useEffect(() => {
    dispatch(AppSetup());
  }, [dispatch]);

  const rules = [
    "Share your unique invitation link or referral code with friends to invite them to join.",

    "Your friend must register using your invitation link or referral code for the referral to be tracked.",

    `A referral reward of ₹${appSetup?.referral_bonus ||
      0} will be credited only after your referred friend completes their first successful deposit.`,

    `The first deposit must be at least ₹${appSetup?.referral_min_deposit ||
      0} to qualify for the referral reward.`,

    "Each referred user can generate a referral reward only once, regardless of the number of future deposits.",

    "Referral rewards are credited automatically to your wallet after the referred user's qualifying first deposit is verified.",

    "Users who register without using your referral code or invitation link cannot be linked to your account later.",

    "Any fraudulent, duplicate, fake, or self-created accounts will result in cancellation of referral rewards.",

    "The platform reserves the right to modify, suspend, or terminate the invitation program at any time.",
  ];
  return (
    <section className="Invitation_Rules">
      <Common_white_header headingText="Invitation Rules" />

      <div className="container">
        <div className="desc_text_hodler">
          <h4>Invitation Reward Program</h4>
          <p>
            Invite friends and earn Reward when they complete their first
            successful deposit.
          </p>
        </div>

        {rules.map((rule, index) => (
          <Rules_card key={index} number={index + 1} rule={rule} />
        ))}
      </div>
    </section>
  );
}

export default Invitation_Rules;
